<template>
    <div class="brand-box">
        <h4>{{ name }}</h4>
        <img :src="list_pic_url" alt="" />
        <p>
            {{ simple_desc }}
        </p>
    </div>
</template>

<script>
import { GetBrandList } from '@/https/http'
export default {
    name: 'brand',
    data() {
        return {
            name: '',
            simple_desc: '',
            list_pic_url: '',
            page: 1,
            size: 1000,
        }
    },
    created() {
        this.getBrandData()
    },
    methods: {
        // 发送请求，获取品牌详情页数据
        getBrandData() {
            GetBrandList({ id: this.$route.query.id }).then((res) => {
                console.log(res);
                this.name = res.data.brand.name
                this.simple_desc = res.data.brand.simple_desc
                this.list_pic_url = res.data.brand.list_pic_url
            })
        },
    }
}
</script>

<style lang="less" scoped>
.brand-box {
    text-align: center;
    font-size: 16px;
    line-height: 40px;
    img {
        width: 100%;
    }
}
</style>